import * as actionTypes from '../consts/actionTypes';

const initialState = {
    loading: false,
    error: false,
    success: true,
    addPrescription: null,
    allPrescriptions: null,
    detailPrescription: null,
    printPrescription: null,
};

export default function prescriptionReducer(state = initialState, action) {

    const responseToReturn = (typeState) => {
        let res = { ...state, success: true };
        if (action.response) {
            res = { ...state, [typeState]: action.response.data, loading: false, error: false, success: true };
        }
        return res;
    };

    const showLoading = () => {
        if (action.type === actionTypes.SHOW_LOADING) {
            return { ...state, loading: action.payload };
        }
        return state;
    };

    const errorReturn = (typeState) => {
        if (action.response && action.type === actionTypes.ERROR_PRESCRIPTION) {
            return { ...state, [typeState]: action.response.data ?? action.response, success: false };
        }
        return state;
    };

    const  clearReducer = ()=> ({ ...state, ...action?.payload});
    
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SHOW_LOADING]: showLoading(),
        [actionTypes.ERROR_PRESCRIPTION]: errorReturn('error'),
        [actionTypes.CLEAR_REDUCER_PRESCRIPTION]: clearReducer(),
        [actionTypes.SUCCESS_POST_PRESCRIPTION]: responseToReturn('addPrescription'),
        [actionTypes.SUCCESS_PRINT_PRESCRIPTION]: responseToReturn('printPrescription'),
        [actionTypes.SUCCESS_GET_DETAIL_PRESCRIPTION]: responseToReturn('detailPrescription'),
        [actionTypes.SUCCESS_GET_ALL_PRESCRIPTIONS]: responseToReturn('allPrescriptions'),
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}